// services/astro-bot-miniapp/src/components/brand/OrbitalRings.tsx
import styles from './OrbitalRings.module.css';

const SIZE = 240;
const R_OUTER = SIZE / 2 - 4;
const R_INNER = SIZE / 2 - 22;

export function OrbitalRings(): JSX.Element {
  const cx = SIZE / 2, cy = SIZE / 2;
  const arcLen = Math.PI * R_OUTER * 0.32;
  const total = Math.PI * 2 * R_OUTER;
  const svgProps = {
    width: SIZE,
    height: SIZE,
    viewBox: `0 0 ${SIZE} ${SIZE}`,
    'aria-hidden': true as const,
  };
  return (
    <div className={styles.root} style={{ width: SIZE, height: SIZE }}>
      {/* Static base ring */}
      <svg {...svgProps} className={styles.layer}>
        <circle cx={cx} cy={cy} r={R_OUTER} fill="none" stroke="var(--gold)" strokeOpacity="0.18" strokeWidth="0.6" />
      </svg>

      {/* Outer gold arc — rotates CW */}
      <svg {...svgProps} className={`${styles.layer} ${styles.ringOuter}`}>
        <defs>
          <linearGradient id="orGold" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="var(--gold-bright)" />
            <stop offset="100%" stopColor="var(--amber)" />
          </linearGradient>
        </defs>
        <circle cx={cx} cy={cy} r={R_OUTER} fill="none" stroke="url(#orGold)" strokeWidth="2"
                strokeDasharray={`${arcLen} ${total}`} strokeLinecap="round"
                transform={`rotate(-90 ${cx} ${cy})`}
                style={{ filter: 'drop-shadow(0 0 10px var(--gold-bright))' }} />
      </svg>

      {/* Inner violet arc — rotates CCW */}
      <svg {...svgProps} className={`${styles.layer} ${styles.ringInner}`}>
        <defs>
          <linearGradient id="orViolet" x1="1" y1="1" x2="0" y2="0">
            <stop offset="0%" stopColor="#c89cff" />
            <stop offset="100%" stopColor="var(--neb-purple)" />
          </linearGradient>
        </defs>
        <circle cx={cx} cy={cy} r={R_OUTER} fill="none" stroke="url(#orViolet)" strokeWidth="2"
                strokeDasharray={`${arcLen} ${total}`} strokeLinecap="round"
                transform={`rotate(90 ${cx} ${cy})`}
                style={{ filter: 'drop-shadow(0 0 10px #c89cff)' }} />
      </svg>

      {/* Dashed inner ring + 12 dots — slow CCW drift */}
      <svg {...svgProps} className={`${styles.layer} ${styles.ringDots}`}>
        <circle cx={cx} cy={cy} r={R_INNER} fill="none" stroke="var(--gold)" strokeOpacity="0.4"
                strokeWidth="0.5" strokeDasharray="3 6" />
        {Array.from({ length: 12 }).map((_, i) => {
          const a = (i * 30 - 90) * (Math.PI / 180);
          const dx = cx + Math.cos(a) * R_INNER;
          const dy = cy + Math.sin(a) * R_INNER;
          return <circle key={i} cx={dx} cy={dy} r={i === 0 ? 2.6 : 1.5}
                         fill="var(--gold-bright)" opacity={i === 0 ? 1 : 0.55} />;
        })}
      </svg>
    </div>
  );
}
